<!--
 * @Description: 
 * @Date: 2020-11-10 16:47:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-27 18:36:58
-->
<template>
  <div>
    <div class="custom-fill-blank" v-if="show">
      <div
        class="multiple"
        :class="{ type2: !multipleType1 }"
        v-if="isMultiple"
      >
        <div class="multiple-1 bi-text-block" v-if="multipleType1">
          <div class="item" v-for="(item, index) in header" :key="index">
            <div class="title">{{ item.label }}</div>
            <div class="content-group">
              <div
                class="content"
                v-for="(aItem, aIndex) in series0data"
                :key="aIndex"
              >
                {{ aItem[item.prop] }}
              </div>
            </div>
          </div>
        </div>
        <div class="multiple-2" v-else>
          <div
            class="item bi-text-block"
            v-for="(item, index) in header"
            :key="index"
          >
            <div class="title">{{ item.label }}</div>
            <div class="content-group">
              <span
                class="content"
                v-for="(aItem, aIndex) in series0data"
                :key="aIndex"
              >
                {{
                  `${aItem[item.prop]}${
                    series0data.length - aIndex > 1 && aItem[item.prop]
                      ? '/'
                      : ''
                  }`
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="normal bi-text-block" v-else>
        <div class="item" v-for="(item, index) in series0data" :key="index">
          {{ item.d }}
        </div>
      </div>
      <div
        v-if="finalDataCount > 0"
        class="bi-table-footer"
        :class="{ multipletype2: isMultiple && !multipleType1 }"
      >
        本次收集数据数：{{ finalDataCount }}
      </div>
    </div>
    <div v-else style="font-size: 15px;color: #666;margin-top: 20px;">
      本项目月度暂未收集到有效数据
    </div>
  </div>
</template>

<script>
export default {
  props: {
    series0data: {
      type: Array,
      default: () => []
    },
    header: {
      type: Array,
      default: () => []
    },
    finalDataCount: {
      type: Number,
      default: 0
    },
    type: {
      type: Number,
      default: 0
    },
    isMultiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      multipleType1: false
    };
  },
  methods: {},
  computed: {
    show() {
      return this.finalDataCount > 0 || [17, 18].includes(this.type);
    }
  },
  created() {
    if (this.isMultiple) {
      this.multipleType1 = Math.random() > 0.5 || this.header.length == 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-fill-blank {
  // display: flex;
  // justify-content: space-around;
  // align-items: center;
  padding-top: 30px;
  text-align: left;
  &-item {
    display: flex;
    flex-wrap: wrap;
    &-block {
      padding: 20px 20px;
      max-width: 100px;
      & > svg {
        margin-bottom: 8px;
        cursor: pointer;
      }
      & > div {
        font-size: 14px;
        color: #323333;
        line-height: 16px;
      }
    }
  }
  .multiple {
    width: 600px;
    margin: 0 auto;
    &.type2 {
      width: 700px;
    }
    &-1 {
      .item {
        font-size: 14px;
        color: #666666;
        line-height: 1.6;
        letter-spacing: 2px;
        .title {
          flex-shrink: 0;
          color: #333;
          font-weight: bold;
          text-align: left;
          margin-bottom: 10px;
        }
        .content-group {
          // display: flex;
          // flex-wrap: wrap;
          & > div {
            margin-right: 30px;
            display: inline;
            &:empty {
              display: none;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
        & + .item {
          margin-top: 20px;
        }
      }
    }
    &-2 {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        margin-bottom: 15px;
        width: 320px;
        font-size: 14px;
        color: #666666;
        line-height: 1.6;
        letter-spacing: 2px;
        .title {
          flex-shrink: 0;
          color: #333;
          font-weight: bold;
          text-align: left;
          margin-bottom: 10px;
        }
        .content-group {
          // display: flex;
          // flex-wrap: wrap;
          & > div {
            display: inline;
            &:empty {
              display: none;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
  .normal {
    margin: 0 auto;
    width: 600px;
    text-align: left;
    display: flex;
    flex-wrap: wrap;
    .item {
      font-size: 14px;
      color: #666666;
      line-height: 1.3;
      letter-spacing: 2px;
      padding: 5px;
      & + .item {
        // margin-top: 15px;
      }
    }
  }
  .bi-table-footer {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    line-height: 1;
    margin: 0 auto;
    margin-top: 14px;
    text-align: right;
    width: 600px;
    letter-spacing: 2px;
    &.multipletype2 {
      width: 700px;
    }
  }
}
</style>
